import React from 'react';
import './About.css';
import SEO from './SEO';
import Link from './Link';
import theDailyCompLogo from "../assets/Main_logo_proto1.svg";

// SVG Icons as Components
const FreeIcon = () => (
    <svg className="feature-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="#FFD700"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" fill="#FFD700"/>
    </svg>
);

const MultiplayerIcon = () => (
    <svg className="feature-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" fill="#2563EB"/>
    </svg>
);

const ChallengeIcon = () => (
    <svg className="feature-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z" fill="#10B981"/>
    </svg>
);

const ProgressIcon = () => (
    <svg className="feature-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="#10B981"/>
    </svg>
);

const ObjectiveIcon = () => (
    <svg className="rule-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#FFD700"/>
    </svg>
);

const PencilIcon = () => (
    <svg className="rule-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="#2563EB"/>
    </svg>
);

const PaletteIcon = () => (
    <svg className="rule-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" fill="#F59E0B"/>
    </svg>
);

const KeyboardIcon = () => (
    <svg className="rule-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z" fill="#6B7280"/>
    </svg>
);

const TrophyIcon = () => (
    <svg className="rule-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z" fill="#FFD700"/>
    </svg>
);

const GroupIcon = () => (
    <svg className="rule-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 12.75c1.63 0 3.07.39 4.24.9 1.08.48 1.76 1.56 1.76 2.73V18H6v-1.61c0-1.18.68-2.26 1.76-2.73 1.17-.52 2.61-.91 4.24-.91zM4 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58C.48 14.9 0 15.62 0 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29zM20 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85-.85-.37-1.79-.58-2.78-.58-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57zM12 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z" fill="#2563EB"/>
    </svg>
);

const LightbulbIcon = () => (
    <svg className="tips-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 21c0 .5.4 1 1 1h4c.6 0 1-.5 1-1v-1H9v1zm3-19C8.1 2 5 5.1 5 9c0 2.4 1.2 4.5 3 5.7V17c0 .5.4 1 1 1h6c.6 0 1-.5 1-1v-2.3c1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7z" fill="#F59E0B"/>
    </svg>
);

const About = () => {
    return (
        <>
            <SEO
                title="About The Daily Comp - Free Multiplayer Word Game"
                description="Learn about The Daily Comp, a free daily word puzzle game where you compete with friends. Discover how to play, game rules, and start your word challenge today."
                keywords="about daily word game, how to play word games, word game rules, multiplayer word puzzle, daily word challenge guide"
            />
            
            <div className="about-page">
                <header className="about-header">
                    <Link to="login">
                        <img 
                            src={theDailyCompLogo} 
                            alt="The Daily Comp Logo" 
                            className="about-logo"
                            style={{ cursor: 'pointer' }}
                        />
                    </Link>
                </header>

                <main className="about-content">
                    {/* About Section */}
                    <section className="about-section">
                        <h1>About The Daily Comp - Free Daily Word Games & Competitions</h1>
                        <div className="about-text">
                            <p>
                                Welcome to <strong>The Daily Comp</strong> – your free, daily word competition platform! 
                                Challenge yourself and compete with friends in exciting word puzzle games that test your 
                                vocabulary, strategy, and speed.
                            </p>
                            <p>
                                Every day brings a new word challenge. Create private competitions with friends, 
                                track your progress on the leaderboard, and see who can solve the puzzle with the 
                                fewest guesses. Whether you're a word game enthusiast or just looking for a fun daily 
                                brain teaser, The Daily Comp offers endless entertainment completely free of charge.
                            </p>
                            <p>
                                Play this addictive word guessing game with friends and compete daily. No downloads 
                                required – just create an account and start playing instantly in your browser.
                            </p>
                        </div>

                        <div className="features-grid">
                            <div className="feature-card">
                                <h3><FreeIcon /> Free Daily Word Game</h3>
                                <p>No hidden costs, no subscriptions. Play unlimited daily word challenges at no charge.</p>
                            </div>
                            <div className="feature-card">
                                <h3><MultiplayerIcon /> Daily Word Competitions</h3>
                                <p>Create private competitions and invite friends. See who ranks highest on the leaderboard.</p>
                            </div>
                            <div className="feature-card">
                                <h3><ChallengeIcon /> Daily Word Challenge</h3>
                                <p>Fresh word puzzles every day. Test your vocabulary and improve your word skills.</p>
                            </div>
                            <div className="feature-card">
                                <h3><ProgressIcon /> Word Game Statistics</h3>
                                <p>View detailed statistics, compare scores, and climb the rankings in your competitions.</p>
                            </div>
                        </div>
                    </section>

                    {/* How to Play Section */}
                    <section className="how-to-section">
                        <h2>How to Play Our Daily Word Game</h2>
                        
                        <div className="rules-container">
                            <div className="rule-item">
                                <h3><ObjectiveIcon /> Word Game Objective</h3>
                                <p>
                                    Guess the secret 5-letter word within the allowed number of attempts (typically 6 guesses). 
                                    The fewer guesses you use, the better your score!
                                </p>
                            </div>

                            <div className="rule-item">
                                <h3><PencilIcon /> How to Make Your Word Guess</h3>
                                <p>
                                    Type a 5-letter word and press Enter or click the Submit button. Each guess must be a valid word.
                                </p>
                            </div>

                            <div className="rule-item">
                                <h3><PaletteIcon /> Understanding the Colors</h3>
                                <div className="color-guide">
                                    <div className="demo-row">
                                        <div className="demo-letter correct-demo">S</div>
                                        <div className="demo-letter unused-demo">H</div>
                                        <div className="demo-letter unused-demo">A</div>
                                        <div className="demo-letter unused-demo">R</div>
                                        <div className="demo-letter unused-demo">E</div>
                                        <p className="demo-explanation">
                                            <span className="color-tag green-tag">Green</span> – The letter <strong>S</strong> is in the word and in the correct position.
                                        </p>
                                    </div>

                                    <div className="demo-row">
                                        <div className="demo-letter unused-demo">P</div>
                                        <div className="demo-letter present-demo">L</div>
                                        <div className="demo-letter unused-demo">A</div>
                                        <div className="demo-letter unused-demo">C</div>
                                        <div className="demo-letter unused-demo">E</div>
                                        <p className="demo-explanation">
                                            <span className="color-tag yellow-tag">Yellow</span> – The letter <strong>L</strong> is in the word but in the wrong position.
                                        </p>
                                    </div>

                                    <div className="demo-row">
                                        <div className="demo-letter absent-demo">B</div>
                                        <div className="demo-letter absent-demo">R</div>
                                        <div className="demo-letter absent-demo">I</div>
                                        <div className="demo-letter absent-demo">C</div>
                                        <div className="demo-letter absent-demo">K</div>
                                        <p className="demo-explanation">
                                            <span className="color-tag gray-tag">Gray/Red</span> – These letters are not in the word at all.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="rule-item">
                                <h3><KeyboardIcon /> Using the Keyboard</h3>
                                <p>
                                    The on-screen keyboard shows you which letters you've tried:
                                </p>
                                <ul>
                                    <li><strong>Green keys</strong> = Letters in the correct position</li>
                                    <li><strong>Yellow keys</strong> = Letters in the word but wrong position</li>
                                    <li><strong>Gray keys</strong> = Letters not in the word</li>
                                    <li><strong>Black keys</strong> = Letters you haven't tried yet</li>
                                </ul>
                            </div>

                            <div className="rule-item">
                                <h3><TrophyIcon /> Word Competition Scoring</h3>
                                <p>
                                    Guess the word correctly to win! Your score is based on how many guesses you used. 
                                    Fewer guesses = better score. Compare your results with friends on the competition leaderboard.
                                </p>
                            </div>

                            <div className="rule-item">
                                <h3><GroupIcon /> Join Daily Word Competitions</h3>
                                <p>
                                    Create a competition and invite friends to play the same daily word. View the leaderboard 
                                    to see who solved it with the fewest guesses. Past competitions are saved so you can 
                                    review previous challenges and results.
                                </p>
                            </div>
                        </div>

                        <div className="tips-section">
                            <h3><LightbulbIcon /> Word Game Pro Tips</h3>
                            <ul className="tips-list">
                                <li>Start with common vowels and consonants to gather information</li>
                                <li>Pay attention to letter frequency in English words</li>
                                <li>Use the color feedback to eliminate possibilities</li>
                                <li>Don't repeat letters you know are absent (gray)</li>
                                <li>If a letter is yellow, try it in different positions</li>
                                <li>Each competition resets daily with a new word challenge</li>
                            </ul>
                        </div>
                    </section>

                    {/* Call to Action */}
                    <section className="cta-section">
                        <h2>Start Playing Daily Word Games Today</h2>
                        <p>Join The Daily Comp and compete in free daily word competitions with friends!</p>
                        <Link to="login" className="cta-button">
                            Sign Up Free
                        </Link>
                        <p className="cta-subtext">
                            Already have an account? <Link to="login" className="link-text">Sign in here</Link>
                        </p>
                    </section>
                </main>

                <footer className="about-footer">
                    <p>&copy; 2026 The Daily Comp. All rights reserved.</p>
                    <div className="footer-links">
                        <Link to="login" className="footer-link">Home</Link>
                    </div>
                </footer>
            </div>
        </>
    );
};

export default About;
